/**
 * Model for Outright Outcomes
 */
export default class OutrightOutcomeModel {
  /**
   * class constructor method
   * @param data
   */
  constructor(data) {
    /**
     * Outcome ID
     * @type {number}
     */
    this.id = data.cmid;
    /**
     * Competitor id
     * @type {number}
     */
    this.cmid = data.cmid;
    /**
     * Outright market id
     * @type {number}
     */
    this.oddTypeOutcomeId = data.otoid;
    /**
     * Outcome Name
     * @type {string}
     */
    this.name = data.n;
    /**
     * Outcome value
     * @type {string}
     */
    this.outcome = data.o;
    /**
     * Outcome value in original format ready for parsing
     */
    this.originalDecimalOutcome = data.o;
    /**
     * Suspended outcome
     * @type {boolean}
     */
    this.suspended = data.su;
  }
}
